/**
 * Google Ads Enhanced Conversion & Event Tracking
 * Tracks: add_to_cart, begin_checkout, view_item, and handles purchase (via Shopify checkout)
 */

(function() {
  'use strict';

  // Wait for gtag to be available
  function waitForGtag(callback) {
    if (typeof gtag !== 'undefined' && window.dataLayer) {
      callback();
    } else {
      setTimeout(function() { waitForGtag(callback); }, 100);
    }
  }

  // Track Add to Cart
  function trackAddToCart(event) {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    // Get product data from form
    const productId = form.querySelector('[name="id"]')?.value;
    const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1');

    // Get product info from hidden inputs or data attributes
    const productPrice = form.querySelector('.ga-product-price')?.value ||
                         form.dataset.productPrice ||
                         form.closest('[data-product-price]')?.dataset.productPrice;
    const productTitle = form.querySelector('.ga-product-title')?.value ||
                         form.dataset.productTitle ||
                         form.closest('[data-product-title]')?.dataset.productTitle;

    if (!productId) return;

    waitForGtag(function() {
      gtag('event', 'add_to_cart', {
        'send_to': 'AW-318512071',
        'value': parseFloat(productPrice) * quantity,
        'currency': 'USD',
        'items': [{
          'id': productId,
          'quantity': quantity,
          'google_business_vertical': 'retail'
        }]
      });

      // Also send to GA4
      gtag('event', 'add_to_cart', {
        'currency': 'USD',
        'value': parseFloat(productPrice) * quantity,
        'items': [{
          'item_id': productId,
          'item_name': productTitle,
          'price': parseFloat(productPrice),
          'quantity': quantity
        }]
      });
    });
  }

  // Track Begin Checkout
  function trackBeginCheckout() {
    // Get cart data from window.Shopify or make fetch request
    if (typeof Shopify !== 'undefined' && Shopify.routes) {
      fetch(Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.item_count === 0) return;

          const cartValue = cart.total_price / 100; // Shopify returns cents
          const items = cart.items.map(item => ({
            'id': item.variant_id.toString(),
            'quantity': item.quantity,
            'google_business_vertical': 'retail'
          }));

          waitForGtag(function() {
            gtag('event', 'begin_checkout', {
              'send_to': 'AW-318512071',
              'value': cartValue,
              'currency': cart.currency || 'USD',
              'items': items
            });

            // Also send to GA4
            gtag('event', 'begin_checkout', {
              'currency': cart.currency || 'USD',
              'value': cartValue,
              'items': cart.items.map(item => ({
                'item_id': item.variant_id.toString(),
                'item_name': item.product_title,
                'price': item.price / 100,
                'quantity': item.quantity
              }))
            });
          });
        })
        .catch(err => {
          // Cart fetch failed silently
        });
    }
  }

  // Track View Item on product pages
  function trackViewItem() {
    const isProductPage = document.body.classList.contains('template-product');
    if (!isProductPage) return;

    // Get product data from meta tags or window
    const productMeta = document.querySelector('meta[property="og:product:price:amount"]');
    const productId = document.querySelector('[data-product-id]')?.dataset.productId;

    if (!productMeta || !productId) return;

    const productPrice = parseFloat(productMeta.content);

    waitForGtag(function() {
      gtag('event', 'view_item', {
        'send_to': 'AW-318512071',
        'value': productPrice,
        'currency': 'USD',
        'items': [{
          'id': productId,
          'google_business_vertical': 'retail'
        }]
      });
    });
  }

  // Initialize event listeners
  function init() {
    // Track add to cart on form submissions
    document.addEventListener('submit', function(event) {
      if (event.target.matches('form[action*="/cart/add"]')) {
        trackAddToCart(event);
      }
    });

    // Track add to cart on quick add buttons
    document.addEventListener('click', function(event) {
      const button = event.target.closest('[name="add"]');
      if (button && button.form) {
        trackAddToCart({ target: button.form });
      }
    });

    // Track begin checkout on checkout button clicks
    document.addEventListener('click', function(event) {
      if (event.target.matches('[name="checkout"], [href*="/checkout"], .checkout-button, [data-checkout-button]')) {
        trackBeginCheckout();
      }
    });

    // Track view item on product page load
    if (document.readyState === 'complete') {
      trackViewItem();
    } else {
      window.addEventListener('load', trackViewItem);
    }
  }

  // Start tracking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
